var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSpAssessment4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 23.927,
    height: 23.927,
    viewBox: "0 0 23.927 23.927",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2.585,35.659q-.008-.2-.008-.4A9.378,9.378,0,0,1,2.764,33.4L.241,32.874A11.958,11.958,0,0,0,0,35.262q0,.251.01.5A11.916,11.916,0,0,0,2.668,42.8l2-1.625a9.333,9.333,0,0,1-2.083-5.514",
    transform: "translate(0 -23.306)",
    fill: "#b1b1b1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.582,65.021A9.355,9.355,0,0,1,12.1,62.415a9.5,9.5,0,0,1-.755-.817l-2,1.627A11.917,11.917,0,0,0,18.582,67.6h.008V65.021h-.006",
    transform: "translate(-6.626 -43.67)",
    fill: "#b1b1b1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.135,33.757h0a12.1,12.1,0,0,0-.323-2.317l-2.5.614a9.439,9.439,0,0,1,.252,1.809q.008.2.008.4A9.336,9.336,0,0,1,66.6,40l2.029,1.589a11.916,11.916,0,0,0,2.515-7.327q0-.251-.01-.5",
    transform: "translate(-47.218 -22.289)",
    fill: "#b1b1b1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.074,61.746a9.351,9.351,0,0,1-6.391,2.888c-.1,0-.208.006-.312.006l0,2.577c.138,0,.276,0,.415-.008a11.93,11.93,0,0,0,8.146-3.681q.4-.417.758-.873l-2.027-1.591c-.187.236-.384.465-.592.682",
    transform: "translate(-29.33 -43.291)",
    fill: "#b1b1b1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.33,39.62l1.462-.061Z",
    transform: "translate(-51.988 -28.045)",
    fill: "#f68d00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.806,2.585q.2-.008.4-.008a9.327,9.327,0,0,1,3.956.875l1.09-2.335A11.9,11.9,0,0,0,28.2,0q-.251,0-.5.01a11.92,11.92,0,0,0-4.8,1.229l1.153,2.3a9.35,9.35,0,0,1,3.758-.958",
    transform: "translate(-16.232 0)",
    fill: "#b1b1b1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.814,8.579a9.417,9.417,0,0,1,2.563-1.9l-1.155-2.3A11.962,11.962,0,0,0,.89,12.594l2.522.524a9.377,9.377,0,0,1,2.4-4.54",
    transform: "translate(-0.631 -3.106)",
    fill: "#9fffe5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.424,7.994A9.36,9.36,0,0,1,60.041,12.5l2.5-.617A11.969,11.969,0,0,0,56.06,3.965L54.967,6.3a9.442,9.442,0,0,1,2.457,1.7",
    transform: "translate(-38.969 -2.811)",
    fill: "#b1b1b1"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpAssessment4);
export default __webpack_public_path__ + "static/media/sp_assessment_4.6ef15152.svg";
export { ForwardRef as ReactComponent };